import React from 'react';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import Link from '../utils/router/Link';
import userPath from '../utils/url/userPath';
import useIsPublicView from '../utils/useIsPublicView';
import type { PresenceAvatarStatus } from './PresenceAvatar';
import PresenceAvatar from './PresenceAvatar';
import * as styles from './PresenceAvatarStack.module.scss';

const PRESENCE_AVATAR_STACK_USER_FRAGMENT = gql(`
  fragment PresenceAvatarStack_user on User {
    id
    ...PresenceAvatar_user
  }
`);

interface PresenceAvatarStackProps {
  users: {
    user: DocumentType<typeof PRESENCE_AVATAR_STACK_USER_FRAGMENT> & {
      index: number;
    };
    status: PresenceAvatarStatus;
  }[];
}

const PresenceAvatarStack = ({ users }: PresenceAvatarStackProps) => {
  const isPublicView = useIsPublicView();
  return (
    <div className={styles.container}>
      {users.map(({ user, status }) => {
        return (
          <div key={user.id} className={styles.avatar}>
            {isPublicView ? (
              <PresenceAvatar status={status} index={user.index} user={user} />
            ) : (
              <Link key={user.id} to={userPath(user)} newTab>
                <PresenceAvatar
                  status={status}
                  index={user.index}
                  user={user}
                />
              </Link>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PresenceAvatarStack;
